import TrendChart from './TrendChart';
import { getValueHistory } from '../../utils/storage';

export default function HealthScore({ score, summary, vehicleId }) {
  const color =
    score >= 80 ? 'var(--success)' : score >= 60 ? 'var(--warning)' : 'var(--danger)';
  const circumference = 2 * Math.PI * 38;
  const offset = circumference - (score / 100) * circumference;

  // Get health score history for trend chart
  const history = vehicleId
    ? getValueHistory(vehicleId)
        .map((h) => ({ date: h.date, value: h.healthScore }))
        .filter((h) => typeof h.value === 'number')
    : [];

  return (
    <div className="card">
      <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
        <div style={{ position: 'relative', flexShrink: 0 }}>
          <svg width="88" height="88" viewBox="0 0 88 88">
            <circle
              cx="44"
              cy="44"
              r="38"
              fill="none"
              stroke="var(--bg-elevated)"
              strokeWidth="5"
            />
            <circle
              cx="44"
              cy="44"
              r="38"
              fill="none"
              stroke={color}
              strokeWidth="5"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              transform="rotate(-90 44 44)"
              style={{ transition: 'stroke-dashoffset 0.8s ease' }}
            />
          </svg>
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <span style={{ fontSize: '1.5rem', fontWeight: 700, color, lineHeight: 1 }}>
              {score}
            </span>
            <span style={{ fontSize: '0.625rem', color: 'var(--text-muted)', marginTop: 2 }}>
              / 100
            </span>
          </div>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h3 style={{ fontSize: '0.9375rem', fontWeight: 600, marginBottom: 4 }}>
            Health Score
          </h3>
          <p style={{ fontSize: '0.8125rem', color: 'var(--text-secondary)', lineHeight: 1.5 }}>
            {summary}
          </p>
        </div>
      </div>

      {/* Health score trend chart */}
      {history.length >= 2 && (
        <TrendChart
          data={history}
          color={color}
          label="Score History"
          formatValue={(v) => `${v}/100`}
        />
      )}
    </div>
  );
}
